import { FilterStates } from "@/Components/Filters";
import { useI18n } from "vue-i18n";
import { endOfDay, startOfDay, subDays } from "date-fns";
import { DateShortcut, getShortcutName } from "@/SharedComponents/Date";
import { usePage } from "@inertiajs/vue3";

export function useDefaultTasksViews() {
    const { t } = useI18n();
    const currentUserId = usePage().props.auth.user.id;

    const DefaultView = Object.freeze({
        ALL: {
            id: "all",
            name: t("admin.tasks.views.all_tasks"),
            default: true,
            filters: new FilterStates(),
        },
        ARCHIVED: {
            id: "archived",
            name: t("admin.tasks.views.archived_tasks"),
            default: true,
            filters: new FilterStates(),
            divider: true,
        },
        ASSIGNED_TO_USER: {
            id: "assigned_to_user",
            name: t("admin.tasks.views.my_tasks"),
            default: true,
            filters: new FilterStates({
                assigned_to: [currentUserId],
            }),
        },
        TODAY: {
            id: "today",
            name: t("admin.tasks.views.today"),
            default: true,
            filters: new FilterStates({
                status: ["scheduled"],
                due_date: {
                    range: {
                        start: startOfDay(new Date()),
                        end: endOfDay(new Date()),
                    },
                    shortcutId: DateShortcut.TODAY,
                    label: getShortcutName(DateShortcut.TODAY),
                },
            }),
        },
        OVERDUE: {
            id: "overdue",
            name: t("admin.tasks.views.overdue_tasks"),
            default: true,
            filters: new FilterStates({
                status: ["open", "scheduled"],
                due_date: {
                    range: {
                        start: null,
                        end: endOfDay(subDays(new Date(), 1)),
                    },
                    shortcutId: DateShortcut.OVERDUE,
                    label: getShortcutName(DateShortcut.OVERDUE),
                },
            }),
        },
        HIGH_PRIORITY: {
            id: "high_priority_tasks",
            name: t("admin.tasks.views.high_priority_tasks"),
            default: true,
            filters: new FilterStates({
                status: ["open", "scheduled"],
                priority: ["high"],
            }),
        },
    });

    const defaultViews = [
        DefaultView.ALL,
        DefaultView.ARCHIVED,
        DefaultView.ASSIGNED_TO_USER,
        DefaultView.TODAY,
        DefaultView.OVERDUE,
        DefaultView.HIGH_PRIORITY,
    ];

    return {
        DefaultView,
        defaultViews,
    };
}
